import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {

};

export const mutations = {

};

export const actions = {

  // CREATE_COLEGIADA({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     commit("SET_LOADING", true); //este loadin esta en el index principalde store
  //     ApiService.guardar(data)
  //       .then(response => {
  //         commit("SET_LOADING", false);
  //         resolve(response);
  //       })
  //       .catch(error => {
  //         console.log(error);
  //         reject(error);
  //       });
  //   });
  // },
  // SHOW_COLEGIADA({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     commit("SET_LOADING", true);
  //     ApiService.get(data)
  //       .then(response => {
  //         commit("SET_LOADING", false);
  //         // commit("SHOW_APELACION", response.data.data.apelacion);
  //         resolve(response);
  //       })
  //       .catch(error => {
  //         commit("SET_LOADING", false);
  //         reject(error);
  //       });
  //   });
  // },
  CREATE_OBSERVACION_COLEGIADA({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  UPDATE_OBSERVACION_COLEGIADA({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService.put(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
};
export const getters = {

};
